module.exports = __webpack_public_path__ + "img/yellow-trend-line-no-ellipses.047fc2a5.svg";